// API DEV BASE LOCAL URL
// export const apiBaseUrl = "http://localhost:3001";

// API DEV BASE URL
 export const apiBaseUrl = "https://api.mylcsh.com";
// export const apiBaseUrl = "http://localhost:5000";
